import styled from "@emotion/styled";

export const BrandLogo = styled.div({
	textAlign: "end"
});
